import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { SsoLoginService } from 'src/app/sso/service/sso-login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  constructor(private router: Router, private ssologin :SsoLoginService) { }

  canActivate() {
    if (localStorage.getItem('token')) {
      return true;
    }
    else {
      // this.router.navigate(['/home']);
      this.ssologin.login()
      return false;
    }
  }
  
}
@Injectable({
  providedIn: 'root'
})
export class PurohitDataAuthGuardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate() {
    if (localStorage.getItem('purohit-token')) {
      return true;
    }
    else {
      this.router.navigate(['/home/kendra-mandir']);
      return false;
    }
  }
}
@Injectable({
  providedIn: 'root'
})
export class AppointPurohitDataAuthGuardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate() {
    if (localStorage.getItem('purohit-token')) {
      this.router.navigate(['/home/kendra-mandir/purohit-data']);
      return false;
    }
    else {
      return true;
    }
  }
  
}
